import { FC } from "react";
import { StyledDotsLoading } from "./style";

const ThreeDotsLoading: FC = () => {
    return <StyledDotsLoading />;
};

export default ThreeDotsLoading;
